module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-85.c9db50e1.svg";